import {Button, IconButton} from "@mui/material";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {clientColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import {useEffect} from "react";

const Clients = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest("/clients");

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (client) => {
    if (!client?.client_id) {
      console.error("Error: No se encuentra al cliente");
      return;
    }
    navigate(`/client-form`, {state: {id: client?.client_id}});
  };

  const handleRowDelete = async (id) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este cliente?");
    if (confirmDelete) {
      try {
        await remove(id);
        list();
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
      }
    }
  };

  const columns = [
    ...clientColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="delete"
          color="secondary"
          onClick={(e) => {
            e.stopPropagation();
            handleRowDelete(params.row.client_id);
          }}
        >
          <FiTrash2 />
        </IconButton>
      )
    }
  ];

  return (
    <Window title={"Clientes"}>
      {loading ? (
        <div style={{textAlign: "center", padding: "20px"}}>
          <span style={{fontSize: "18px", color: "#666"}}>Cargando...</span>
        </div>
      ) : (
        <ListView
          columns={columns}
          data={data}
          getRowId={(row) => row.client_id}
          onRowClick={handleRowClick}
          TopRigthButtons={
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              onClick={() => {
                navigate(`/client-form`);
              }}
            >
              Nuevo cliente
            </Button>
          }
        />
      )}
    </Window>
  );
};

export default Clients;
